module.exports = __webpack_public_path__ + "media/images/ss-dashboard-dba703805099f63dd05c423218f067c8.jpg";